import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useApi, useAuth } from "../../hooks";
import { ServicesApi } from "../../apis";
import { Enums } from "../../utils";

const useViewModel = () => {
  const successModalRef = useRef({ open: () => {}, close: () => {} });
  const authLayoutRef = useRef({ open: () => {}, close: () => {} });
  const [hasAlarm, setHasAlarm] = useState(true);
  const [packages, setPackages] = useState([]);
  const [searchParams] = useSearchParams();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { execute } = useApi();

  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    ServicesApi.devicePackages().then(setPackages);
  }, []);

  useEffect(() => {
    if (searchParams.get("success") && !!sessionId)
      successModalRef.current.open();
  }, [searchParams, sessionId]);

  const subscribe = async () => {
    const { id } = await execute(() => ServicesApi.subscription(sessionId));
    navigate(`/${Enums.pagesNames.subscription}/${id}`);
  };

  const next = ({ authenticated = isAuthenticated, ...device }) => {
    if (!device.supported) {
      navigate(`/${Enums.pagesNames.otherDevice}/${device.uuid}`, {
        state: {
          device: { name: device.name },
          readUrl: device.readUrl,
          ...device.unsupported,
        },
      });
      return;
    }
    if (!authenticated) {
      authLayoutRef.current.login.open(device);
      return;
    }
    navigate(
      `/${Enums.pagesNames.servicePaymentPlans}?state=${JSON.stringify({
        type: device.uuid,
        successUrl:
          window.location.origin + window.location.pathname + `?success=true`,
      })}`
    );
  };

  return {
    hasAlarm,
    packages,
    refs: {
      authLayout: authLayoutRef,
      successModal: successModalRef,
    },
    next,
    subscribe,
    setHasAlarm,
  };
};

export default useViewModel;
